import {
  useOrderFormStore,
  useOrderFormStoreActions,
} from '@/modules/order/stores/order-form.store'
import type { IOrderFormJson } from '@/modules/order/types/order-form-json.type'

import { useProductStore } from '../stores/product.store'
import type { TProducts } from '../types/product.type'

export const useCrudProductInOrderHook = () => {
  const { jsonOrderForm } = useOrderFormStore()
  const { setJsonOrderForm } = useOrderFormStoreActions()
  const {
    products,
    productsInsertedInOrderToCalculation,
    actions: { setProducts, setProductsInsertedInOrderToCalculation },
  } = useProductStore()

  const changeOrder = (order: IOrderFormJson) => {
    setJsonOrderForm(order)
  }

  const addProduct = (product: TProducts) => {
    const order = {
      ...jsonOrderForm,
      itemsCalculo: [...jsonOrderForm.itemsCalculo, product],
    }

    const idToCalculation = [
      ...productsInsertedInOrderToCalculation,
      product.fkProduto,
    ]
    setProductsInsertedInOrderToCalculation(idToCalculation)

    changeOrder(order)
  }

  const updateProduct = (product: TProducts) => {
    const idToCalculation = [
      ...productsInsertedInOrderToCalculation,
      product.fkProduto,
    ]
    setProductsInsertedInOrderToCalculation(idToCalculation)

    if (product.quantidade === 0) {
      const order = {
        ...jsonOrderForm,
        itemsCalculo: jsonOrderForm.itemsCalculo.filter(
          (item) => item.fkProduto !== product.fkProduto,
        ),
      }

      changeOrder(order)
      return
    }

    const order = {
      ...jsonOrderForm,
      itemsCalculo: jsonOrderForm.itemsCalculo.map((item) =>
        item.fkProduto === product.fkProduto ? product : item,
      ),
    }

    const updatedProducts = products?.map((item) =>
      item.fkProduto === product.fkProduto ? product : item,
    )
    setProducts(updatedProducts)

    changeOrder(order)
  }

  return {
    addProduct,
    updateProduct,
  }
}
